import { ChevronRightRounded } from '@mui/icons-material';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Switch } from '@mui/material';
import { setTransportSelectedItemConditionOptions, setTransportSelectedItemParkingPointsOptions } from 'app/actions/map';
import { MapTransportTrackIntervalMenu } from 'app/pages/Map';
import { getLastConditionData } from 'app/types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const MapTransportConditionTrackList = () => {
    var _a, _b;
    const dispatch = useDispatch();
    const { ref: mapRef } = useSelector((state) => state.map);
    const { conditions, parkingPointsOptions, conditionOptions, device_type } = (_a = useSelector((state) => state.map.transportSelectedItem)) !== null && _a !== void 0 ? _a : { conditions: [] };
    const [anchorTrackIntervalEl, setAnchorTrackIntervalEl] = useState(null);
    const handleTrackVisibleChange = () => {
        var _a, _b, _c, _d;
        dispatch(setTransportSelectedItemConditionOptions(Object.assign(Object.assign({}, conditionOptions), { visible: !(conditionOptions === null || conditionOptions === void 0 ? void 0 : conditionOptions.visible) })));
        const lastData = getLastConditionData(conditions);
        if ((lastData === null || lastData === void 0 ? void 0 : lastData.lat) != null && (lastData === null || lastData === void 0 ? void 0 : lastData.lon) != null) {
            (_b = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.handleClosePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _c === void 0 ? void 0 : _c.handleFlyTo) === null || _d === void 0 ? void 0 : _d.call(_c, [lastData.lat, lastData.lon]);
        }
    };
    const handleParkingPointsVisibleChange = () => dispatch(setTransportSelectedItemParkingPointsOptions(Object.assign(Object.assign({}, parkingPointsOptions), { visible: !(parkingPointsOptions === null || parkingPointsOptions === void 0 ? void 0 : parkingPointsOptions.visible) })));
    const formatInterval = (hour) => {
        moment.relativeTimeThreshold('h', 25);
        return `${hour > 1 ? '' : '1 '}${moment.duration(hour, 'hours').humanize()}`;
    };
    const handleTackIntervalOpen = (event) => {
        setAnchorTrackIntervalEl(event.currentTarget);
    };
    const handleTackIntervalClose = () => {
        setAnchorTrackIntervalEl(null);
    };
    return (React.createElement(List, { disablePadding: true, sx: (theme) => ({
            '.MuiListItem-root': {
                padding: theme.spacing(0),
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    overflow: 'hidden',
                    '&:after': {
                        content: '""',
                        width: '100%',
                        height: '1px',
                        bgcolor: theme.palette.divider,
                        position: 'absolute',
                        bottom: '0',
                    },
                    '&:hover': {
                        bgcolor: 'transparent',
                    },
                    '.MuiListItemText-root': {
                        display: 'flex',
                        margin: theme.spacing(0),
                        justifyContent: 'space-between',
                        '.MuiTypography-root': {
                            lineHeight: '24px',
                        },
                    },
                    '.MuiListItemIcon-root': {
                        minWidth: '28px',
                        justifyContent: 'flex-end',
                    },
                    '.MuiSwitch-switchBase:hover': {
                        bgcolor: 'transparent',
                    },
                },
                '&:last-of-type': {
                    '.MuiListItemButton-root:after': {
                        display: 'none',
                    },
                },
            },
        }) },
        React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, onClick: handleTrackVisibleChange },
                React.createElement(ListItemText, { primary: '\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0442\u0440\u0435\u043A \u043D\u0430 \u043A\u0430\u0440\u0442\u0435' }),
                React.createElement(Switch, { size: 'small', edge: 'end', disableRipple: true, checked: !!(conditionOptions === null || conditionOptions === void 0 ? void 0 : conditionOptions.visible) }))),
        ['galileosky'].includes(config.transportDeviceTypes[device_type]) && (React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, onClick: handleParkingPointsVisibleChange },
                React.createElement(ListItemText, { primary: '\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043A\u043E\u0432\u043A\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0435' }),
                React.createElement(Switch, { size: 'small', edge: 'end', disableRipple: true, checked: !!(parkingPointsOptions === null || parkingPointsOptions === void 0 ? void 0 : parkingPointsOptions.visible) })))),
        React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, onClick: handleTackIntervalOpen },
                React.createElement(ListItemText, { primary: '\u0418\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F', secondary: formatInterval((_b = conditionOptions === null || conditionOptions === void 0 ? void 0 : conditionOptions.interval) !== null && _b !== void 0 ? _b : 24) }),
                React.createElement(ListItemIcon, null,
                    React.createElement(ChevronRightRounded, { fontSize: 'small' }))),
            React.createElement(MapTransportTrackIntervalMenu, { anchorEl: anchorTrackIntervalEl, open: !!anchorTrackIntervalEl, onClose: handleTackIntervalClose }))));
};
export default MapTransportConditionTrackList;
